import React from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import { Link } from 'react-router-dom'
import { FollowTheSigns } from '@mui/icons-material'
import { ClockIcon } from '@mui/x-date-pickers'

function CounterDashboardPage() {
  return (
    <AppLayout>
      <div className='container'>
        <div className='row mt-5 text-center'>
          <div className='col-md-6 my-3'>
              <div className='card bg-primary p-3 ' >
                <Link to="/counter/checkin-queue" className='btn text-white'   >
                  <h3><FollowTheSigns style={{fontSize:60}} /></h3>
                  <p>Checkin Queue</p>
                </Link>
              </div>
          </div>

          <div className='col-md-6 my-3'>
              <div className='card bg-success p-3 ' >
                <Link to="/counter/appointment-queue" className='btn text-white'   >
                  <h3><ClockIcon style={{fontSize:60}} /></h3>
                  <p>Appointment Queue</p>
                </Link>
              </div>
          </div>
        </div>
      </div>
            
        
    </AppLayout>
  )
}

export default CounterDashboardPage